import FancyButton from './FancyButton';

export default FancyButton;